import { io } from 'socket.io-client';

// Connect to your backend server
const socket = io(process.env.REACT_APP_SOCKET_URL);

export default socket;
